import React from 'react'
import { Alert } from 'react-bootstrap'

const AlertError = ({textoError}) => {
  return (
    <Alert variant="danger" className='p-2'>
        <p className='mb-0'>{textoError}</p>
    </Alert>
  )
}

export default AlertError